/*
 * The palette's keyboard shortcut, named the way each platform names it.
 *
 * ⌘K on a Mac and an iPad with a keyboard, Ctrl K everywhere else. Printing
 * "Ctrl K" on a Mac would teach a shortcut that does nothing there — Ctrl+K
 * on macOS moves the caret.
 */

export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false

  const platform =
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ||
    navigator.platform ||
    navigator.userAgent

  return /mac|iphone|ipad|ipod/i.test(platform)
}

export function shortcutLabel(key = 'K'): string {
  return isApplePlatform() ? `⌘${key}` : `Ctrl ${key}`
}

/** Ctrl+K or ⌘K, and nothing with Shift or Alt on top. */
export function isPaletteShortcut(event: KeyboardEvent): boolean {
  return (
    (event.ctrlKey || event.metaKey) &&
    !event.altKey &&
    !event.shiftKey &&
    event.key.toLowerCase() === 'k'
  )
}
